import { useEffect, useState } from "react";
import { Archive, Download, FileUp, LoaderCircle, ShieldCheck } from "lucide-react";
import { api, MigrationJob, MigrationPolicy } from "../../../api";

export function DataPrivacySettings({ openMigration }: { openMigration: () => void }) {
  const [policy, setPolicy] = useState<MigrationPolicy | null>(null);
  const [jobs, setJobs] = useState<MigrationJob[]>([]);
  const [error, setError] = useState("");
  useEffect(() => {
    Promise.all([api.migrationPolicy(), api.migrationJobs()])
      .then(([nextPolicy, result]) => { setPolicy(nextPolicy); setJobs(result.jobs); })
      .catch(reason => setError(reason instanceof Error ? reason.message : "无法读取数据策略"));
  }, []);
  return <section className="setting-section data-privacy-settings">
    <header><h2>数据与隐私</h2><p>管理自己邮箱的数据副本、导入任务和迁移记录。</p></header>
    {error && <div className="settings-error" role="alert">{error}</div>}
    {!policy && !error ? <div className="settings-loading"><LoaderCircle className="spin" />正在读取数据策略</div> : policy && <>
      <article className="setting-card"><span><Download /></span><div><h3>导出我的全部邮件</h3><p>支持 MBOX 与 Maildir。{policy.forceExportPassword ? "管理员要求导出包必须设置独立密码。" : "可自行选择是否使用独立密码加密。"}</p></div><ShieldCheck /></article>
      <article className="setting-card"><span><FileUp /></span><div><h3>导入与邮箱迁移</h3><p>支持 EML、MBOX、Maildir ZIP 和加密 IMAPS 一次性迁移{policy.allowContinuousSync ? `，管理员允许最长 ${policy.maxContinuousDays} 天持续同步` : ""}。</p></div></article>
      <div className="setting-actions"><button className="setting-primary" onClick={openMigration}><Archive />进入导入与导出中心</button><span>当前共有 {jobs.length} 个迁移或导出任务</span></div>
    </>}
  </section>;
}
